angular.module('impactx.demandbundle').controller('DemandBundleDetailCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'DemandBundleService',
    '$errorHandler',
    'ToolbarService',
    DemandBundleDetailCtrl
]);

function DemandBundleDetailCtrl($scope, dataGen, $routeParams, DemandBundleService, $errorHandler, ToolbarService) {
    var ctrl = this;

    dataGen.getData($scope, {id: $routeParams.id}, "/demandbundle/view").then(function () {
        $scope.scrollList.push({id: 'header', label: $scope.trns.headerTitle});
        var i = 0;
        angular.forEach($scope.data.object.supplierHeaderList, function (contract) {
            $scope.scrollList.push({
                id: 'csc' + i++,
                label: (contract.contractName ? contract.contractName + " " : "") + "(" + contract.contractNo + ")"
            });
        });
        $scope.scrollList.push({id: 'basketSum', label: $scope.trns.sum});
        ToolbarService.setScrollMenu($scope.scrollList);
        defineButtons();
    });
    $scope.scrollList = [];

    this.getItemsToProcess = function () {
        var items = [];
        if ($scope.selectedPurchaseItems.length > 0) {
            items = $scope.selectedPurchaseItems;
        }
        else {
            var i = 0;
            var supplierHeaderList = $scope.selectedSupplier.length > 0 ? $scope.selectedSupplier : $scope.data.object.supplierHeaderList;
            while (i < supplierHeaderList.length) {
                var j = 0;
                var order = $scope.data.object.supplierHeaderList[i];
                while (j < order.requestItems.length) {
                    items.push(order.requestItems[j]);
                    j++;
                }
                i++;
            }

        }
        return items;
    };

    this.hasHeaderComments = function (items) {
        var validItemFound = false;
        var hasHeaderComments = false;
        var i = 0;
        hasHeaderComments = hasHeaderComments || (impactX.isDefined($scope.data.object,
            'comments.internalComments.comments') && $scope.data.object.comments.internalComments.comments.length > 0);
        hasHeaderComments = hasHeaderComments || (impactX.isDefined($scope.data.object,
            'comments.externalComments.comments') && $scope.data.object.comments.externalComments.comments.length > 0);
        //we need to iterate over the list of supplier headers AND items and check if one item of the supplier header
        //is selected. If so, we can check if the supplier header has comments.
        while (i < $scope.data.object.supplierHeaderList.length) {
            var j = 0;
            var order = $scope.data.object.supplierHeaderList[i];
            while (j < order.requestItems.length) {
                if (items.indexOf(order.requestItems[j]) > -1) {
                    validItemFound = true;
                    hasHeaderComments = hasHeaderComments || (impactX.isDefined($scope.data.object.supplierHeaderList[i],
                        'comments.internalComments.comments') && $scope.data.object.supplierHeaderList[i].comments.internalComments.comments.length > 0);
                    hasHeaderComments = hasHeaderComments || (impactX.isDefined($scope.data.object.supplierHeaderList[i],
                        'comments.externalComments.comments') && $scope.data.object.supplierHeaderList[i].comments.externalComments.comments.length > 0);
                    break;
                }
                j++;
            }
            i++;
        }

        return validItemFound && hasHeaderComments;
    };

    this.checkAccounting = function (items) {
        var i = 0;
        while (i < items.length) {
            var control = items[i].control;
            if (ctrl.hasControlSet(control)) {
                return true;
            }
            i++;
        }
        return ctrl.hasHeaderAccounting(items);
    };

    this.hasHeaderAccounting = function (items) {
        var hasHeaderControl = false;
        var validItemFound = false;
        var i = 0;
        hasHeaderControl = ctrl.hasControlSet($scope.data.object.control);
        //we need to iterate over the list of supplier headers AND items and check if one item of the supplier header
        //is selected. If so, we can check if the supplier header has controls.
        while (i < $scope.data.object.supplierHeaderList.length) {
            var j = 0;
            var order = $scope.data.object.supplierHeaderList[i];
            while (j < order.requestItems.length) {
                if (items.indexOf(order.requestItems[j]) > -1) {
                    validItemFound = true;
                    hasHeaderControl = hasHeaderControl || ctrl.hasControlSet($scope.data.object.supplierHeaderList[i].control);
                    break;
                }
                j++;
            }
            i++;
        }

        return validItemFound && hasHeaderControl;
    };

    this.hasControlSet = function (control) {
        return control.crd.set.length > 0 ||
            control.ctrlA.set.length > 0 ||
            control.ctrlB.set.length > 0 ||
            control.ctrlC.set.length > 0 ||
            control.ctrlD.set.length > 0 ||
            control.ctt.set.length > 0 ||
            control.ctu.set.length > 0 ||
            control.prj.set.length > 0 ||
            control.psp.set.length > 0 ||
            control.act.set.length > 0 ||
            control.net.set.length > 0;
    };

    this.hasOGDInfo = function () {
        return $scope.data.object.supplierHeaderList.some(function (des) {
            return des.hasOGDInfo;
        });
    };

    this.hasSPOInfo = function () {
        return $scope.data.object.supplierHeaderList.some(function (des) {
            return des.hasSPOInfo;
        });
    };

    this.bundleAndAddToCurrentBasket = function (event) {
        var items = ctrl.getItemsToProcess();
        var unbundledItemsWhole = DemandBundleService.getUnbundledItemsWhole(items);

        var hasItemComments = false;
        var hasHeaderComments = ctrl.hasHeaderComments(unbundledItemsWhole);
        var hasMaterialGroupMappings = false;
        var hasOGDInfo = ctrl.hasOGDInfo();
        var hasSPOInfo = ctrl.hasSPOInfo();
        angular.forEach(unbundledItemsWhole, function (selectedItem) {
            hasMaterialGroupMappings = hasMaterialGroupMappings || selectedItem.hasMaterialGroupMapping;
            hasItemComments = hasItemComments || (impactX.isDefined(selectedItem, 'comments.internalComments.comments') && selectedItem.comments.internalComments.comments.length > 0);
            hasItemComments = hasItemComments || (impactX.isDefined(selectedItem, 'comments.externalComments.comments') && selectedItem.comments.externalComments.comments.length > 0);
        });
        var hasAccountings = ctrl.checkAccounting(unbundledItemsWhole);

        var unbundledItems = DemandBundleService.getUnbundledItems(items);
        if (unbundledItems.length === 0) {
            $errorHandler.showErrors([{error: $scope.trns.noBundleError}]);
            return;
        }
        if (hasAccountings || hasMaterialGroupMappings || hasItemComments || hasHeaderComments || hasOGDInfo || hasSPOInfo) {
            DemandBundleService.showAddToBasketDialog(event, unbundledItems, hasAccountings, true, true, false, hasItemComments, hasMaterialGroupMappings, hasHeaderComments, hasOGDInfo, hasSPOInfo);
        }
        else {
            DemandBundleService.bundleAndAddToBasketRequest(unbundledItems, 0, false, false, false, false, false,
                false, 0, 0);
        }
    };

    this.bundleAndAddToSelectionBasket = function (event) {
        var items = ctrl.getItemsToProcess();
        var unbundledItemsWhole = DemandBundleService.getUnbundledItemsWhole(items);

        var hasItemComments = false;
        var hasHeaderComments = ctrl.hasHeaderComments(unbundledItemsWhole);
        var hasMaterialGroupMappings = false;
        var hasOGDInfo = ctrl.hasOGDInfo();
        var hasSPOInfo = ctrl.hasSPOInfo();
        angular.forEach(unbundledItemsWhole, function (selectedItem) {
            hasMaterialGroupMappings = hasMaterialGroupMappings || selectedItem.hasMaterialGroupMapping;
            hasItemComments = hasItemComments || (impactX.isDefined(selectedItem, 'comments.internalComments.comments') && selectedItem.comments.internalComments.comments.length > 0);
            hasItemComments = hasItemComments || (impactX.isDefined(selectedItem, 'comments.externalComments.comments') && selectedItem.comments.externalComments.comments.length > 0);
        });

        var unbundledItems = DemandBundleService.getUnbundledItems(items);
        if (unbundledItems.length === 0) {
            $errorHandler.showErrors([{error: $scope.trns.noBundleError}]);
            return;
        }
        var hasAccountings = ctrl.checkAccounting(unbundledItemsWhole);
        DemandBundleService.showAddToBasketDialog(event, unbundledItems, hasAccountings, false, true,
            false, hasItemComments, hasMaterialGroupMappings, hasHeaderComments, hasOGDInfo, hasSPOInfo);

    };

    this.denyItems = function () {
        DemandBundleService.denyItems(DemandBundleService.getUnbundledItems($scope.selectedPurchaseItems), true, false);
    };
    this.denyHeader = function () {
        DemandBundleService.denyHeader($scope.data.object.id, true, false);
    };
    this.denySupplierHeader = function () {
        DemandBundleService.denyItems(DemandBundleService.getUnbundledItems($scope.selectedSupplier.requestItems), true, false);
    };

    $scope.selectedPurchaseItems = [];
    $scope.showItemComments = {value: false};
    this.toggleItemComment = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };
    $scope.showHeaderComment = {value: false};
    this.toggleComment = function () {
        $scope.showHeaderComment.value = !$scope.showHeaderComment.value;
    };
    $scope.showComments = {value: false};
    $scope.selectedSupplier = [];
    this.toggleSupplierComment = function () {
        $scope.showComments.value = !$scope.showComments.value;
    };
    this.selectSupplier = function (event, supplier) {
        if (event.target.tagName != "MD-SELECT" &&
            (!event.target.parentNode.tagName || event.target.parentNode.tagName != "MD-SELECT-VALUE")
            && (!event.target.parentNode.tagName || !event.target.parentNode.parentNode.tagName || event.target.parentNode.parentNode.tagName != "MD-SELECT-VALUE")) {
            $scope.showComments.value = false;
            for (var i = 0; i < $scope.selectedPurchaseItems.length; i++) {
                $scope.selectedPurchaseItems[i].selected = false;
            }
            $scope.selectedPurchaseItems.splice(0, 1);

            if ($scope.selectedSupplier[0] !== supplier) {
                $scope.selectedSupplier[0] = supplier;
            }
            else {
                $scope.selectedSupplier.splice(0, 1);
            }
        }
    };

    ctrl.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.comments,
                action: ctrl.toggleComment,
                type: 'dialogaction',
                condition: hasNothingSelected
            },
            {
                label: $scope.trns.comments,
                action: ctrl.toggleItemComment,
                type: 'dialogaction',
                condition: hasItemsSelected
            },
            {
                label: $scope.trns.comments,
                action: ctrl.toggleSupplierComment,
                type: 'dialogaction',
                condition: hasSupplierHeaderSelected
            },
            {
                label: $scope.trns.print,
                type: 'print',
                params: {
                    printToken: $scope.printTokens.demand
                }
            },
            {
                label: $scope.trns.bundleAndAddToSelectionBasket,
                action: ctrl.bundleAndAddToSelectionBasket,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.bundleAndAddToCurrentBasket,
                action: ctrl.bundleAndAddToCurrentBasket,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.deny,
                action: ctrl.denyItems,
                type: 'dialogaction',
                condition: hasItemsSelected
            },
            {
                label: $scope.trns.deny,
                action: ctrl.denyHeader,
                type: 'dialogaction',
                condition: hasNothingSelected
            },
            {
                label: $scope.trns.deny,
                action: ctrl.denySupplierHeader,
                type: 'dialogaction',
                condition: hasSupplierHeaderSelected
            },
            {
                label: $scope.trns.approvalmodifiedpri,
                linkFunction: getApprovalModifyLink,
                type: 'link',
                condition: canViewApprovalModification
            },
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function hasNothingSelected() {
        return !$scope.selectedPurchaseItems.length && !$scope.selectedSupplier.length;
    }

    function hasItemsSelected() {
        return $scope.selectedPurchaseItems.length > 0;
    }

    function hasSupplierHeaderSelected() {
        return $scope.selectedSupplier.length > 0;
    }

    function getApprovalModifyLink() {
        return "approvalmodifieddei/" + $scope.selectedPurchaseItems[0].id;
    }

    function canViewApprovalModification() {
        return $scope.selectedPurchaseItems.length == 1 && $scope.selectedPurchaseItems[0].showApprovalModifiedLink;
    }
}